package it.unibo.tuprolog.solve.stdlib.function

import it.unibo.tuprolog.core.Integer
import it.unibo.tuprolog.core.Numeric
import it.unibo.tuprolog.core.Real
import it.unibo.tuprolog.solve.ExecutionContext
import it.unibo.tuprolog.solve.function.UnaryMathFunction
import kotlin.math.ceil

/**
 * Implementation of `ceiling/1` arithmetic functor
 *
 * @author Enrico
 */
object Ceiling : UnaryMathFunction("ceiling") {
    override val help: String =
        """
        `ceiling(+Number)`
        
        Evaluates to the smallest integer not less than `Number`. Integer inputs are returned unchanged.

        **Examples**

        ```prolog
        ?- X is ceiling(2.1).
        X = 3.

        ?- X is ceiling(-2.9).
        X = -2.

        ?- X is ceiling(5).
        X = 5.
        ```
        """.trimIndent()

    override fun mathFunction(
        integer: Integer,
        context: ExecutionContext,
    ): Numeric = integer

    override fun mathFunction(
        real: Real,
        context: ExecutionContext,
    ): Numeric = Numeric.of(ceil(real.value.toDouble()).toLong())
}
